<main class="workout-library">
  <header class="library-hero">
    <div class="library-hero__copy">
      <div class="library-hero__eyebrow">
        <mat-icon>list_alt</mat-icon>
        {{ _pt('workouts_title') }}
      </div>
      <h1>Plan every session</h1>
      <p>
        Browse the sessions your athletes train with, see how each one is built
        at a glance, and keep your training plans organized.
      </p>

      <div class="library-hero__stats" *ngIf="!isLoading">
        <span>
          <strong>{{ totalCount }}</strong>
          {{ countLabel(totalCount) }}
        </span>
        <span *ngIf="workouts.length">
          <strong>{{ workouts.length }}</strong>
          on this page
        </span>
      </div>
    </div>

    <div class="library-hero__actions">
      <a
        mat-flat-button
        class="create-workout-button"
        [routerLink]="_pt('create_workout_link')"
      >
        <mat-icon>add</mat-icon>
        {{ _pt('create_workout_title') }}
      </a>
      <a
        mat-stroked-button
        class="deleted-workouts-button"
        [routerLink]="deletedWorkoutsLink"
      >
        <mat-icon>delete_outline</mat-icon>
        {{ _pt('deleted_workouts') }}
      </a>
    </div>
  </header>

  <section class="selection-bar" *ngIf="selectedWorkouts.length > 0">
    <div class="selection-bar__count">
      <span>{{ selectedWorkouts.length }}</span>
      selected
    </div>
    <div class="selection-bar__actions">
      <button
        type="button"
        class="bulk-action-button bulk-action-button--outline"
        (click)="clearSelection()"
      >
        <mat-icon>close</mat-icon>
        <span>Clear selection</span>
      </button>
      <button
        type="button"
        class="bulk-action-button bulk-action-button--primary"
        *ngIf="isSuperAdmin"
        (click)="openPushWorkoutsDialog()"
      >
        <mat-icon>cloud_upload</mat-icon>
        <span>{{ _pt('push_workouts_to_locaitons') }}</span>
      </button>
    </div>
  </section>

  <section class="loading-state" *ngIf="isLoading">
    <mat-spinner diameter="44"></mat-spinner>
    <p>Loading your {{ workoutNounPlural }}…</p>
  </section>

  <section class="empty-library" *ngIf="!isLoading && workouts.length === 0">
    <div class="empty-library__icon">
      <mat-icon>list_alt</mat-icon>
    </div>
    <h2>No {{ workoutNounPlural }} here yet</h2>
    <p>
      Create your first {{ workoutNoun }} to start building sessions from your
      exercise library.
    </p>
    <a
      mat-flat-button
      class="create-workout-button"
      [routerLink]="_pt('create_workout_link')"
    >
      <mat-icon>add</mat-icon>
      {{ _pt('create_workout_title') }}
    </a>
  </section>

  <ng-container *ngIf="!isLoading && workouts.length > 0">
    <section class="library-toolbar">
      <mat-checkbox
        color="primary"
        class="library-toolbar__select-all"
        *ngIf="isSuperAdmin"
        [checked]="allOnPageSelected"
        [indeterminate]="isOneSelected && !allOnPageSelected"
        (change)="allOnPageSelected ? clearSelection() : selectAllOnPage()"
      >
        Select all on this page
      </mat-checkbox>

      <mat-paginator
        class="library-toolbar__paginator"
        [length]="totalCount"
        [pageIndex]="page"
        [pageSize]="itemsPerPage"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="changePage($event)"
        aria-label="Select page"
      >
      </mat-paginator>
    </section>

    <div class="workout-grid">
      <a class="workout-create-tile" [routerLink]="_pt('create_workout_link')">
        <span class="workout-create-tile__icon">
          <mat-icon>add</mat-icon>
        </span>
        <strong>{{ _pt('create_workout_title') }}</strong>
        <span class="workout-create-tile__hint">
          Build a new {{ workoutNoun }} from your exercises
        </span>
      </a>

      <app-workout-card
        *ngFor="let workout of workouts; trackBy: trackByWorkoutId"
        [isSelectionActive]="isOneSelected"
        [workout]="workout"
        (_delete)="deleteWorkout(workout.id)"
      ></app-workout-card>
    </div>
  </ng-container>
</main>
